module.exports = __webpack_public_path__ + "static/img/1000000435_green.2e17dc0d.jpg";